import {
    isOrgsHiddenForDevelopTab,
    isOrgUiEnabled,
} from '@thoughtspot/session-service';
import React, { createContext, useContext, useState } from 'react';

interface NavHubContextOptions {
    tseOrgContext?: string;
    setTseOrgContext?: any;
}

const NavHubContext = createContext<NavHubContextOptions>(
    {} as NavHubContextOptions,
);

export const useNavHubContext = () => useContext(NavHubContext);

interface NavHubContextProviderProps {
    children: React.ReactNode;
    currentContext?: string;
}

export const NavHubContextProvider: React.FC<NavHubContextProviderProps> = ({
    children,
    currentContext,
}) => {
    // This state is used to identify the tab selection in left nav panel- All Orgs, Primary Orgs
    const [tseOrgContext, setTseOrgContext] = useState(() => {
        if (currentContext) {
            return currentContext;
        }
        // Default context logic similar to EverywhereContext
        if (isOrgUiEnabled() && !isOrgsHiddenForDevelopTab()) {
            return 'primary-org';
        }
        return 'all-org';
    });

    return (
        <NavHubContext.Provider
            value={{
                tseOrgContext,
                setTseOrgContext,
            }}
        >
            {children}
        </NavHubContext.Provider>
    );
};
